import { getDiclensionDatasource } from '@monoimin/datasources';
import { Locales } from '@monoimin/sb-types';
import { getCountryName } from '@monoimin/utils/formatters';

export const declineCountry = async (
  countryCode: string | number,
  decline: 'И' | 'Р' | 'П' | 'М',
  locale: Locales
) => {
  if (typeof countryCode !== 'string') {
    return '';
  }

  if (locale !== 'ru') {
    return getCountryName(countryCode, locale);
  }

  const datasources = await getDiclensionDatasource();

  const item = datasources[countryCode as keyof typeof datasources];

  return item[decline] || '';
};
